import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { accountSettingRoutes } from '@routes/routes-by-domain/account.ts';
import { accountsRoutes } from '@routes/routes-by-domain/accounts.ts';
import { approvalsRoutes } from '@routes/routes-by-domain/approvals.ts';
import { authRoutes } from '@routes/routes-by-domain/auth.ts';
import { campaignsRoutes } from '@routes/routes-by-domain/campaigns.ts';
import { datapoolsRoutes } from '@routes/routes-by-domain/datapools.ts';
import { iamRoutes } from '@routes/routes-by-domain/iam.ts';
import { insightsRoutes } from '@routes/routes-by-domain/insights.ts';
import { invitationsRoutes } from '@routes/routes-by-domain/invitations.ts';
import { learningCenterRoutes } from '@routes/routes-by-domain/learning-center.ts';

import { responsesRoutes } from '@routes/routes-by-domain/responses.ts';
import { solversRoutes } from '@routes/routes-by-domain/solvers.ts';
import { studioRoutes } from '@routes/routes-by-domain/studio.ts';
import { tablesRoutes } from '@routes/routes-by-domain/tables.ts';
import { workspaceRoutes } from '@routes/routes-by-domain/workspace.ts';
import { ResourceType } from '@vincerosoft/assessfluence-types';
import type { ComponentType } from 'react';

export type LazyRouteModule = {
  default: ComponentType;
};

export type RouteNavMeta = {
  breadcrumbKey?: string;
  hideBack?: boolean;
  breadcrumbLabel?: string; // Static label
  backTo?: string; // path template like "/studio/:id"
  backToSearch?: Record<string, string>;
};

export type AppRouteConfig = {
  path?: string;
  index?: boolean;
  lazyImport?: () => Promise<LazyRouteModule>;
  redirectTo?: string;
  redirectState?: unknown;
  requiresAuth?: boolean;
  resourceId?: ResourceType;
  redirectUnauthorizedTo?: string;
  children?: ReadonlyArray<AppRouteConfig>;
  nav?: RouteNavMeta;
};

export const appRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: '__',
    lazyImport: () => import('./components/OutletRoute.tsx'),
    children: authRoutes
  },
  {
    path: 'auth',
    redirectTo: '/__/auth'
  },
  {
    path: 'guest',
    lazyImport: () => import('../domains/public/guest/GuestRoute.tsx')
  },
  {
    path: 'pub',
    lazyImport: () => import('../domains/public/pub/PublicRoute.tsx')
  },
  {
    path: '/',
    lazyImport: () => import('../domains/protected/main/MainRoute.tsx'),
    requiresAuth: true,
    children: [
      {
        index: true,
        lazyImport: () => import('../domains/protected/home/HomeRoute.tsx')
      },
      ...accountSettingRoutes,
      ...accountsRoutes,
      {
        path: 'api',
        resourceId: 'api',
        lazyImport: () => import('../domains/protected/api/ApiRoute.tsx'),
        requiresAuth: true
      },
      ...approvalsRoutes,
      ...campaignsRoutes,
      ...datapoolsRoutes,
      {
        path: baseRoutes.files.root,
        lazyImport: () => import('../domains/protected/filestore/FileStoreRoute.tsx'),
        requiresAuth: true,
        resourceId: 'file'
      },
      ...iamRoutes,
      ...insightsRoutes,
      ...invitationsRoutes,
      ...learningCenterRoutes,
      ...responsesRoutes,
      ...solversRoutes,
      ...studioRoutes,
      ...tablesRoutes,
      {
        path: 'user-profile',
        lazyImport: () => import('../domains/protected/user-profile/UserProfileRoute.tsx'),
        requiresAuth: true
      },
      ...workspaceRoutes
    ]
  },
  {
    path: '*',
    redirectTo: '/'
  }
];
